// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

const classPrefix = 'notification-alert';

export class Notification extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { notification } = this.props;
        return (
            <div className={`${notification.classes || ''} ${classPrefix} ${classPrefix}-${notification.type} ${classPrefix}-banner animated ${notification.animation}`}>
                <div className={`${classPrefix}-text`}>
                    <i className={`togo-icon togo-icon-${notification.iconType}`}></i>
                    <span>{notification.text}</span>
                </div>
            </div>
        );
    }
}
Notification.propTypes = {
    t: PropTypes.func,
    notification: PropTypes.object.isRequired
};
export default connect(state => {
    return (
        {
            notification: state.notification
        }
    );
}
)(translate(['translation'])(Notification));



// WEBPACK FOOTER //
// ./src/components/SharedComponents/notification/notification.js